import React, { useState } from 'react';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { initializeSongsWithVotes } from '../../data/setlistStore';

/**
 * Utility component to update Firebase rankings to custom top 20
 * Now uses centralized setlistStore for consistency
 */
export const UpdateRankingsButton = () => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');

  const updateRankings = async () => {
    if (!window.confirm('Initialize setlist with optimal totalVotes distribution?\n\nTop 20: 10,000 → 3,000 votes\nSongs 21-50: 2,800 → 200 votes\n\nThis gives top 20 songs a strong head start for cumulative mode.')) {
      return;
    }

    setLoading(true);
    setStatus('Updating...');

    try {
      // Use centralized store initialization
      const songs = initializeSongsWithVotes();

      // Save to Firebase
      const docRef = doc(db, 'adminSetlist', 'currentSetlist');
      await setDoc(docRef, {
        songs,
        updatedAt: new Date().toISOString(),
        updatedBy: 'custom-top-20-update-v2',
        lastAdminUpdate: new Date().toISOString(),
        isManualOverride: true,
        isActive: true
      });

      setStatus('Rankings updated successfully!');
      console.log('Firebase updated successfully!');
      console.log('\nTop 20 Priority Songs (with strong totalVotes head start):');
      songs.slice(0, 20).forEach((song, i) => {
        console.log(`${String(i + 1).padStart(2, '0')}. ${song.title} (Votes: ${song.totalVotes.toLocaleString()}, Score: ${song.score.toFixed(3)})`);
      });

      setTimeout(() => {
        setStatus('');
        window.location.reload();
      }, 2000);

    } catch (error) {
      console.error('Error updating Firebase:', error);
      setStatus(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ margin: '1rem 0' }}>
      <button
        onClick={updateRankings}
        disabled={loading}
        style={{
          padding: '0.75rem 1.5rem',
          fontSize: '1rem',
          fontWeight: 'bold',
          backgroundColor: '#feda2d',
          color: '#000',
          border: 'none',
          borderRadius: '4px',
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.6 : 1
        }}
      >
        {loading ? 'Updating...' : 'Initialize Top 20 Priority (Optimal Distribution)'}
      </button>
      {status && (
        <p style={{ marginTop: '0.5rem', color: status.includes('success') ? '#0FA52A' : '#EF0000' }}>
          {status}
        </p>
      )}
    </div>
  );
};

export default UpdateRankingsButton;
